<template>
  <div class="app-container xmzk_ywgzgl">
    <div class="app-content">
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane label="指标规则管理" name="zbgzgl"></el-tab-pane> -->
      <div>
        <div class="card card1">
          <div class="card-header">
            <div class="card-title">
              <div>指标配置管理</div>
            </div>
            <div class="card-more">
              <el-select
                v-model="filterStatus1"
                filterable
                placeholder="请选择指标状态"
                size="mini"
                style="width: 200px; margin-right: 10px"
                class="filter-item"
                clearable
                @change="handleChangeCard1Status"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                placeholder="请输入指标名称"
                v-model="filterZbmc1"
                class="input-with-select"
                size="mini"
                style="width: 100%; margin-bottom: 15px"
                maxlength="50"
                @input="
                  (e) => {
                    getZbfhr(1, 10);
                  }
                "
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </div>
          <div class="content">
            <div>
              <el-table
                :data="zbfhrList"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
                border
                :header-cell-style="tableHeaderColor"
                style="margin-top: 15px"
              >
                <el-table-column
                  label="工作事件"
                  align="center"
                  prop="gzsj"
                  :show-overflow-tooltip="true"
                  min-width="200"
                />
                <el-table-column
                  label="指标名称"
                  align="center"
                  min-width="200"
                  prop="zbmc"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="审批人"
                  align="center"
                  min-width="200"
                  prop="xms"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="指标状态"
                  align="center"
                  min-width="80"
                  prop="status"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.status == "1" ? "启用" : "禁用" }}
                    </div>
                  </template>
                  <template slot="header">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top"
                      :open-delay="500"
                    >
                      <div slot="content">控制过程检查是否显示</div>
                      <div class="table_header">
                        指标状态&nbsp;
                        <img src="@/img/u285.svg" height="16" alt="" />
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  label="开始日期"
                  align="center"
                  min-width="100"
                  prop="qsrq"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="结束日期"
                  align="center"
                  min-width="100"
                  prop="jsrq"
                  :show-overflow-tooltip="true"
                >
                  <template slot="header">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top"
                      :open-delay="500"
                    >
                      <div slot="content">
                        ①控制指标在规定的时间范围内进行判定<br />
                        ②控制质量报表在规定的时间范围内进行统计<br />
                      </div>
                      <div class="table_header">
                        结束日期&nbsp;
                        <img src="@/img/u285.svg" height="16" alt="" />
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作列"
                  align="center"
                  prop="content"
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="small"
                      plain
                      @click="handleEditZbfhr(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      type="primary"
                      size="small"
                      plain
                      @click="handleAssignZbfhr(scope.row)"
                      >分配</el-button
                    >
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
              <el-pagination
                :current-page="zbfhrParams.page"
                :page-size="zbfhrParams.pageSize"
                layout="total,  prev, pager, next"
                :total="zbfhrCount"
                v-if="zbfhrCount"
                @current-change="
                  (e) => {
                    getZbfhr(e, zbfhrParams.pageSize);
                  }
                "
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="card card2">
          <div class="card-header">
            <div class="card-title">
              <div>最佳模型节点绑定</div>
            </div>
            <div class="card-more">
              <el-select
                v-model="filterStatus2"
                filterable
                placeholder="请选择指标状态"
                size="mini"
                style="width: 200px; margin-right: 10px"
                class="filter-item"
                clearable
                @change="handleChangeCard2Status"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-input
                placeholder="请输入指标名称"
                v-model="filterZbmc2"
                class="input-with-select"
                size="mini"
                style="width: 100%; margin-bottom: 15px"
                maxlength="50"
                @input="
                  (e) => {
                    getZjmxbd(1, 10);
                  }
                "
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </div>
          <div class="content">
            <div>
              <el-table
                :data="zjmxbdList"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
                border
                :header-cell-style="tableHeaderColor"
                style="margin-top: 15px"
              >
                <el-table-column
                  label="项目阶段"
                  align="center"
                  min-width="200"
                  prop="jd"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="指标名称"
                  align="center"
                  min-width="200"
                  prop="zbmc"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="关键动作/规划"
                  align="center"
                  prop="jdname"
                  min-width="200"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="指标状态"
                  align="center"
                  min-width="80"
                  prop="status"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.status == "1" ? "启用" : "禁用" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="开始日期"
                  align="center"
                  min-width="100"
                  prop="qsrq"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="结束日期"
                  align="center"
                  min-width="100"
                  prop="jsrq"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="操作列"
                  align="center"
                  prop="content"
                  min-width="80"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="small"
                      plain
                      @click="handleEditZjmxbd(scope.row)"
                      >编辑</el-button
                    >
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
              <el-pagination
                :current-page="zjmxbdParams.page"
                :page-size="zjmxbdParams.pageSize"
                layout="total, prev, pager, next"
                :total="zjmxbdCount"
                v-if="zjmxbdCount"
                @current-change="
                  (e) => {
                    getZjmxbd(e, zjmxbdParams.pageSize);
                  }
                "
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="card card3">
              <div class="card-header">
                <div class="card-title"><div>风险预警设置</div></div>
                <div class="card-more">
                  <el-button
                    label="left"
                    type="primary"
                    size="mini"
                    @click="handleSaveFxyj"
                  >
                    保存
                  </el-button>
                </div>
              </div>
              <div class="content">
                <div class="fxsz">
                  <el-radio-group v-model="fxyj.fxsz">
                    <el-radio label="1">启用预警设置</el-radio>
                    <el-radio label="0">关闭预警设置</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="fxyj.fxsz == 1">
                  <div class="yj-time">
                    <el-checkbox v-model="jdzbCheck">季度指标</el-checkbox>
                    <div>
                      <div>
                        黄色预警：提前
                        <el-input-number
                          v-model="fxyj.jdzb_yellow"
                          :min="0"
                          :max="90"
                          label="描述文字"
                          size="mini"
                          :step="1"
                          step-strictly
                        ></el-input-number>
                        天内（含）
                      </div>
                      <div>
                        红色预警：提前
                        <el-input-number
                          v-model="fxyj.jdzb_red"
                          :min="0"
                          :max="45"
                          label="描述文字"
                          size="mini"
                          :step="1"
                          step-strictly
                        ></el-input-number>
                        天内（含）
                      </div>
                    </div>
                  </div>
                  <div class="yj-time">
                    <el-checkbox v-model="bndzbCheck">半年度指标</el-checkbox>
                    <div>
                      <div>
                        黄色预警：提前
                        <el-input-number
                          v-model="fxyj.bndzb_yellow"
                          :min="0"
                          :max="180"
                          label="描述文字"
                          size="mini"
                          :step="1"
                          step-strictly
                        ></el-input-number>
                        天内（含）
                      </div>
                      <div>
                        红色预警：提前
                        <el-input-number
                          v-model="fxyj.bndzb_red"
                          :min="0"
                          :max="90"
                          label="描述文字"
                          size="mini"
                          :step="1"
                          step-strictly
                        ></el-input-number>
                        天内（含）
                      </div>
                    </div>
                  </div>
                  <div class="yj-time">
                    <el-checkbox v-model="ndzbCheck">年度指标</el-checkbox>
                    <div>
                      <div>
                        黄色预警：提前
                        <el-input-number
                          v-model="fxyj.ndzb_yellow"
                          :min="0"
                          :max="360"
                          label="描述文字"
                          size="mini"
                          :step="1"
                          step-strictly
                        ></el-input-number>
                        天内（含）
                      </div>
                      <div>
                        红色预警：提前
                        <el-input-number
                          v-model="fxyj.ndzb_red"
                          :min="0"
                          :max="180"
                          label="描述文字"
                          size="mini"
                          :step="1"
                          step-strictly
                        ></el-input-number>
                        天内（含）
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card card4" style="margin-left: 15px">
              <div class="card-header">
                <div class="card-title"><div>复核超时设置</div></div>
                <div class="card-more">
                  <el-button
                    label="left"
                    type="primary"
                    size="mini"
                    @click="handleSaveFhcs"
                  >
                    保存
                  </el-button>
                </div>
              </div>
              <div class="content">
                <div>
                  <el-radio-group v-model="fxyj.fhsz">
                    <el-radio label="1">启用超时设置</el-radio>
                    <el-radio label="0">关闭超时设置</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="fxyj.fhsz == 1">
                  <div style="margin-bottom: 15px">
                    <el-input-number
                      v-model="fxyj.fhsj"
                      :min="1"
                      :max="999"
                      label="描述文字"
                      size="mini"
                      :step="1"
                      step-strictly
                    ></el-input-number>
                    小时内（含），需要复核完成。
                  </div>
                  <div>
                    <span>复核超时后，默认为：</span>
                    <el-radio-group v-model="fxyj.fhmr">
                      <el-radio label="1">通过</el-radio>
                      <el-radio label="0">不通过</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <el-tab-pane label="配置管理" name="second">XXX管理</el-tab-pane>
        <el-tab-pane label="配置管理" name="second">XXX管理</el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>
    <el-dialog
      v-if="shrEditVisible"
      width="700px"
      :closeOnClickModal="false"
      :visible.sync="shrEditVisible"
    >
      <div class="card card-zdbj">
        <div class="card-header">
          <div class="card-title">
            <div>编辑</div>
          </div>
        </div>
        <div>
          <el-form
            ref="editShrForm"
            label-width="120px"
            :model="shrEditRow"
            :hide-required-asterisk="false"
            :rules="editRules"
          >
            <el-form-item label="工作事件：" prop="gzsj">
              <el-input
                show-word-limit
                placeholder=""
                v-model="shrEditRow.gzsj"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="指标名称：" prop="zbmc">
              <el-input
                show-word-limit
                placeholder=""
                v-model="shrEditRow.zbmc"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="指标状态：" prop="status">
              <el-select
                ref="status"
                v-model="shrEditRow.status"
                placeholder="指标状态"
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
              >
                <el-option
                  v-for="item in zbStatusList"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期：" prop="qsrq">
              <el-date-picker
                v-model="editTime[0]"
                style="width: 100%"
                type="date"
                placeholder="开始日期"
                size="small"
                :clearable="false"
              ></el-date-picker
            ></el-form-item>
            <el-form-item label="结束日期：" prop="jsrq">
              <el-date-picker
                v-model="editTime[1]"
                style="width: 100%"
                type="date"
                placeholder="开始日期"
                :pickerOptions="pickerOptionsEnd"
                size="small"
                :clearable="false"
              ></el-date-picker
            ></el-form-item>
          </el-form>
        </div>
        <div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="shrEditVisible = false" size="smalll">
              取消
            </el-button>
            <el-button type="primary" size="smalll" @click="handleEditZbgz()">
              确定
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="shrAssignVisible"
      width="700px"
      :closeOnClickModal="false"
      :visible.sync="shrAssignVisible"
    >
      <div class="card card-zdbj">
        <div class="card-header">
          <div class="card-title">
            <div>审核人分配</div>
          </div>
        </div>
        <div>
          <el-form
            ref="assignShrForm"
            label-width="120px"
            :model="assignShrForm"
            :hide-required-asterisk="false"
            style="margin-top: 15px"
          >
            <el-form-item label="指标名称：" prop="sjr">
              <el-input
                show-word-limit
                placeholder=""
                v-model="shrAssignRow.zbmc"
                disabled
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属部门：" prop="courseGroup">
              <el-select
                v-model="assignShrForm.bmbh"
                placeholder="所属部门"
                clearable
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
                @change="handleChangeBm"
              >
                <el-option
                  v-for="item in bmList"
                  :key="item.bmbh"
                  :label="item.bmmc"
                  :value="item.bmbh"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属条线：" prop="txlx">
              <el-select
                ref="txlx"
                v-model="assignShrForm.txlx"
                placeholder="所属条线"
                clearable
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
                @change="handleChangeTxlx"
              >
                <el-option
                  v-for="item in txlxList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
            <div>
              <el-transfer
                v-model="chickShrList"
                filterable
                filter-placeholder="请输入角色名称"
                :titles="['未选列表', '已选列表']"
                :data="ygList"
                class="transfer-box"
                ref="shr_transfer"
                :props="{
                  key: 'ygbh',
                  label: 'xm',
                }"
                @change="handleChangeTransfer"
              ></el-transfer>
            </div>
          </el-form>
        </div>
        <div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="shrAssignVisible = false" size="smalll">
              取消
            </el-button>
            <el-button type="primary" size="smalll" @click="handleSaveZbgz(0)">
              确定
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="modelEditVisible"
      width="700px"
      :closeOnClickModal="false"
      :visible.sync="modelEditVisible"
    >
      <div class="card card-zdbj">
        <div class="card-header">
          <div class="card-title">
            <div>节点绑定</div>
          </div>
        </div>
        <div>
          <el-form
            label-width="120px"
            :hide-required-asterisk="false"
            style="margin-top: 15px"
          >
            <el-form-item label="指标名称：">
              <el-input
                show-word-limit
                placeholder=""
                v-model="modelEditRow.zbmc"
                disabled
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="关键动作/规划：">
              <el-cascader
                ref="cascaderModal"
                :options="modelList"
                style="width: 100%"
                v-model="chickModelList"
                collapse-tags
                filterable
                clearable
                @visible-change="handleChangeModal"
                :props="{
                  multiple: true,
                  emitPath: false,
                  value: 'id',
                  label: 'title',
                  checkStrictly: true,
                }"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.title }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="modelEditVisible = false" size="smalll">
              取消
            </el-button>
            <el-button type="primary" size="smalll" @click="handleSaveZbgz(1)">
              确定
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "@/router";
import {
  getZjmxbdList,
  getZbfhrList,
  getFxyjData,
  getYgList,
  saveFhcs,
  saveFxyj,
  saveZbgz,
  editZbgl,
} from "@/api/xmzk";
import { getBmxxList } from "@/api/common";
import { getKeyValue } from "@/api/taskType.js";
import { getProgramModelList } from "@/api/program.js";
import moment from "moment";
import { deepClone } from "@/utils/utils";

export default {
  computed: {
    ...mapGetters(["moduleList"]),
  },
  data() {
    return {
      year: null,
      radio: 1,
      activeName: "zbgzgl",
      zjmxbdParams: {
        page: 1,
        pageSize: 10,
      },
      zjmxbdList: [],
      zjmxbdCount: 0,
      zbfhrParams: {
        page: 1,
        pageSize: 10,
      },
      zbfhrList: [],
      zbfhrCount: 0,
      fxyj: {},
      jdzbCheck: true,
      bndzbCheck: true,
      ndzbCheck: true,
      bmList: [],
      txlxList: [],
      assignShrForm: {
        txlx: null,
        bmbh: null,
      },
      ygList: [],
      chickShrList: [],
      shrAssignVisible: false,
      shrAssignRow: {},
      modelList: [],
      chickModelList: [],
      modelEditVisible: false,
      modelEditRow: {},
      filterZbmc1: null,
      filterZbmc2: null,
      filterStatus2: null,
      filterStatus1: null,

      statusOptions: [
        { key: "禁用", value: 0 },
        { key: "启用", value: 1 },
      ],
      chickShrListCopy: [],
      shrEditVisible: false,
      zbStatusList: [
        { key: "启用", value: 1 },
        { key: "禁用", value: 0 },
      ],
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.editTime[0]) {
            return time.getTime() < new Date(this.editTime[0]).getTime();
          }
        },
      },
      editTime: [],
      shrEditRow: {},
      editRules: {
        gzsj: [
          { required: true, message: "工作事件不能为空", trigger: "change" },
        ],
        zbmc: [
          { required: true, message: "指标名称不能为空", trigger: "change" },
        ],
        status: [
          { required: true, message: "指标状态不能为空", trigger: "change" },
        ],
        qsrq: [
          { required: true, message: "开始日期不能为空", trigger: "change" },
        ],
        jsrq: [
          { required: true, message: "结束日期不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getZjmxbd(1, 10);
    this.getZbfhr(1, 10);
    this.getFxyj();
    getBmxxList({ type: 2 }).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.txlxList = res.data;
      }
    });
    this.getYg();
  },
  mounted() {
    document.querySelector(".xmzk_ywgzgl").parentNode.style.overflow = "hidden";
    document.querySelector(".xmzk_ywgzgl").parentNode.style.height = "100%";
    document.querySelector(".xmzk_ywgzgl").parentNode.style.overflow = "auto";
  },
  methods: {
    getZjmxbd(page, pageSize) {
      this.zjmxbdParams = {
        page,
        pageSize,
        zbmc: this.filterZbmc2,
        status: this.filterStatus2,
      };
      getZjmxbdList(this.zjmxbdParams).then((res) => {
        if (res.code == 0) {
          // this.zjmxbdList = res.data;
          this.zjmxbdList = res.data.data ? res.data.data : [];
          this.zjmxbdCount = res.data.count ? res.data.count : 0;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getZbfhr(page, pageSize) {
      this.zbfhrParams = {
        page,
        pageSize,
        zbmc: this.filterZbmc1,
        status: this.filterStatus1,
      };
      getZbfhrList(this.zbfhrParams).then((res) => {
        if (res.code == 0) {
          this.zbfhrList = res.data.data ? res.data.data : [];
          this.zbfhrCount = res.data.count ? res.data.count : 0;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getFxyj() {
      getFxyjData().then((res) => {
        if (res.code == 0) {
          let temp = {};
          const data = res.data;
          for (let i of data) {
            temp[i.label] = i.value;
          }
          this.fxyj = temp;
          // this.fxyj.jdzb = true;
          // this.fxyj.bndzb = true;
          // this.fxyj.ndzb = true;
          this.jdzbCheck = this.fxyj.jdzb == "1";
          this.bndzbCheck = this.fxyj.bndzb == "1";
          this.ndzbCheck = this.fxyj.ndzb == "1";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getYg() {
      getYgList(this.assignShrForm).then((res) => {
        if (res.code == 0) {
          this.ygList = res.data;
          for (let i of this.chickShrListCopy) {
            this.ygList.push(i);
          }
          let some = [];
          this.ygList.forEach((el) => {
            if (!some.some((e) => e.ygbh == el.ygbh)) {
              some.push(el);
            }
          });
          this.ygList = some;
        }
      });
    },
    handleEditZjmxbd(row) {
      this.modelEditVisible = true;
      this.modelEditRow = row;
      if (row.jdid) {
        this.chickModelList = row.jdid.split(",");
      } else {
        this.chickModelList = [];
      }

      this.handleResetAssign();
      this.getModelList();
    },
    getModelList() {
      getProgramModelList({ xmbh: null, isTree: 1 }).then((res) => {
        if (res.code == 0) {
          this.modelList = res.data;
        }
      });
    },
    handleEditZbfhr(row) {
      this.shrEditVisible = true;
      this.shrEditRow = deepClone(row);
      this.editTime[0] = moment(this.shrEditRow.qsrq);
      this.editTime[1] = moment(this.shrEditRow.jsrq);
      if (row.ygbhs) {
        let temp = [];
        this.chickShrList = row.ygbhs.split(",");
        temp = row.xms.split(",");
        for (let i in temp) {
          this.chickShrListCopy.push({
            xm: temp[i],
            ygbh: this.chickShrList[i],
          });
        }
      } else {
        this.chickShrList = [];
        this.chickShrListCopy = [];
      }
      this.handleResetAssign();
    },
    handleAssignZbfhr(row) {
      this.shrAssignVisible = true;
      this.shrAssignRow = row;
      if (row.ygbhs) {
        let temp = [];
        this.chickShrList = row.ygbhs.split(",");
        temp = row.xms.split(",");
        for (let i in temp) {
          this.chickShrListCopy.push({
            xm: temp[i],
            ygbh: this.chickShrList[i],
          });
        }
      } else {
        this.chickShrList = [];
        this.chickShrListCopy = [];
      }
      this.handleResetAssign();
    },
    handleChangeBm(e) {
      this.assignShrForm.bmbh = e;
      this.getYg();
    },
    handleChangeTxlx(e) {
      this.assignShrForm.txlx = e;
      this.getYg();
    },
    handleResetAssign() {
      this.assignShrForm.bmbh = null;
      this.assignShrForm.txlx = null;
      // this.chickModelList = [];

      this.getYg();
    },
    handleSaveFhcs() {
      let params = {};
      if (this.fxyj.fhsz == 1) {
        params = {
          fhsz: this.fxyj.fhsz,
          fhsj: this.fxyj.fhsj,
          fhmr: this.fxyj.fhmr,
        };
      } else {
        params = {
          fhsz: this.fxyj.fhsz,
          fhsj: null,
          fhmr: null,
        };
      }
      saveFhcs(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSaveFxyj() {
      let params = {
        fxsz: this.fxyj.fxsz,
        jdzb: +this.jdzbCheck,
        bndzb: +this.bndzbCheck,
        ndzb: +this.ndzbCheck,
      };
      if (this.fxyj.fxsz == 1) {
        if (this.jdzbCheck) {
          params.jdzb_yellow = this.fxyj.jdzb_yellow;
          params.jdzb_red = this.fxyj.jdzb_red;
        }
        if (this.bndzbCheck) {
          params.bndzb_yellow = this.fxyj.bndzb_yellow;
          params.bndzb_red = this.fxyj.bndzb_red;
        }
        if (this.ndzbCheck) {
          params.ndzb_yellow = this.fxyj.ndzb_yellow;
          params.ndzb_red = this.fxyj.ndzb_red;
        }
      }
      saveFxyj(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSaveZbgz(type) {
      let params = {
        type,
      };
      if (type == 0) {
        params.zbid = this.shrAssignRow.zbid;
        params.jdspr = this.chickShrList.join(",");
      } else {
        params.zbid = this.modelEditRow.zbid;
        params.zjmxjdid = this.chickModelList.join(",");
      }
      saveZbgz(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.shrAssignRow = {};
          this.chickShrList = [];
          if (type == 0) {
            this.getZbfhr(this.zbfhrParams.page, this.zbfhrParams.pageSize);
            this.shrAssignVisible = false;
          } else {
            this.modelEditVisible = false;
            this.getZjmxbd(this.zjmxbdParams.page, this.zjmxbdParams.pageSize);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeTransfer() {
      setTimeout(() => {
        this.chickShrListCopy = this.$refs.shr_transfer.targetData;
      }, 50);
    },
    handleEditZbgz() {
      this.$refs["editShrForm"].validate((valid) => {
        if (valid) {
          const { gzsj, zbmc, status, zbid } = this.shrEditRow;
          const data = {
            gzsj,
            zbmc,
            status,
            qsrq: this.editTime[0]
              ? moment(this.editTime[0]).format("YYYYMMDD")
              : null,
            jsrq: this.editTime[1]
              ? moment(this.editTime[1]).format("YYYYMMDD")
              : null,
            zbid,
          };
          editZbgl(data).then((res) => {
            if (res.code == 0) {
              this.shrEditVisible = false;
              this.$message.success(res.msg);
              this.getZbfhr(this.zbfhrParams.page, this.zbfhrParams.pageSize);
            } else {
              this.$message.error("操作失败");
            }
          });
        }
      });
    },
    handleChangeCard2Status(i) {
      this.filterStatus2 = i;
      this.getZjmxbd(1, 10);
    },
    handleChangeCard1Status(i) {
      this.filterStatus1 = i;
      this.getZbfhr(1, 10);
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  min-height: 100%;
  // min-width: 1500px;
  background-color: #eef2f8;
  padding: 10px;
  box-sizing: border-box;
  font-family: "Arial Negreta" !important;
}
.app-title {
  font-size: 16px;
  font-weight: 700;
  margin: 15px 0;
}
.app-content {
  padding: 0 15px;
}
.card3,
.card4 {
  height: 436px;
  .content {
    padding: 15px 15px 0 15px;

    > div {
      margin-bottom: 15px;
    }
  }
}
.card {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  margin-bottom: 15px;
  .card-header {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .card-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      > div {
        padding-left: 15px;
      }
    }
    .card-title::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
    }
    .card-more {
      color: #999;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
.card2 .card-more,
.card1 .card-more {
  display: flex;
}
.fxsz {
  border-bottom: 1px solid #efefef;
  padding-bottom: 15px;
}
.yj-time {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  border-bottom: 1px solid #efefef;
  line-height: 42px;
  padding-bottom: 10px;
  > label {
    width: 120px;
  }
}
.transfer-box {
  justify-content: center;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.zdbj-btn {
  display: flex;
  justify-content: center;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.table_header {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-left: 5px;
  }
}
</style>
